module.exports = __webpack_public_path__ + "img/roadwise.bf0fcb60.png";